import axiosInstance from './axiosInstance';

const NotificationService = {
    getAll: () => axiosInstance.get('/api/notifications'),
    getUnreadCount: () => axiosInstance.get('/api/notifications/unread-count'),
    markRead: (id) => axiosInstance.put(`/api/notifications/${id}/read`),
    markAllRead: () => axiosInstance.put('/api/notifications/read-all'),
};

export default NotificationService;
